const sumInsuredList = [
  {id: 1, value: '1 Lac'},
  {id: 2, value: '2 Lacs'},
  {id: 3, value: '3 Lacs'},
  {id: 4, value: '4 Lacs'},
  {id: 5, value: '5 Lacs'},
]

export default sumInsuredList;